import React, {Suspense} from 'react'
import setPreferredTeamId from '~/utils/relay/setPreferredTeamId'
import teamDashMainQuery, {

} from '../../../__generated__/TeamDashMainQuery.graphql'
import useAtmosphere from '../../../hooks/useAtmosphere'
import useQueryLoaderNow from '../../../hooks/useQueryLoaderNow'
import useRouter from '../../../hooks/useRouter'
import TeamDashMain from './TeamDashMain/TeamDashMain'

const TeamDashMainRoot = () => {
  const {match} = useRouter()
  const {params} = match
  const {teamId} = params
  const atmosphere = useAtmosphere()
  setPreferredTeamId(atmosphere, teamId)
  const queryRef = useQueryLoaderNow(teamDashMainQuery, {teamId})
  return React.createElement(Suspense, { fallback: '',}, queryRef && React.createElement(TeamDashMain, { queryRef: queryRef,} ))
}

export default TeamDashMainRoot
